import React from 'react';
import { Modal } from "react-bootstrap";
import { Link } from 'react-router-dom';
import { diffCheck } from '../../../../../../util/Helpers';
import ErrorMessage from './ErrorMessage';


const KYCDocument = ({show, action: {action, error, actedOn, data}, onHide}) => {

    return <Modal
            show={show}
            onHide={onHide}
            aria-labelledby="contained-modal-title-vcenter"
          >
            <Modal.Header >
              <Modal.Title id="contained-modal-title-vcenter">
              <i className="flaticon2-layers-2 text-primary mr-2"></i> {action}
              </Modal.Title>
              <button type="button" className="close" onClick={onHide}>
                  <span aria-hidden="true" className="d-block">×</span>
                  <span className="sr-only">Close</span>
               </button>
            </Modal.Header>
            <Modal.Body>
                <ErrorMessage {...{error}} />
                <div className="px-md-5">
                    <div className="row">
                        <div className="col-md-4 h6">
                            User
                        </div>
                        <div className="col-md h6 text-muted">
                            <Link to={`/users/view/${data?.userId}`} target="_blank" >
                                {actedOn ?? `${data.meta?.firstName ?? ""} ${data.meta?.lastName ?? ""}`}
                            </Link>
                        </div>
                    </div>
                    <div className="row mt-4">
                        <div className="col-md-4 h6">
                            Document Id
                        </div>
                        <div className="col-md h6 text-muted">
                                {data?.documentId}
                        </div>
                    </div>
                    <div className="row mt-4">
                        <div className="col-md-4 h6">
                            User Group
                        </div>
                        <div className="col-md h6 text-muted">
                            {data.userGroup}
                        </div>
                    </div>
                    <div className="row mt-4">
                        <div className="col-md-4 h6">
                            Category
                        </div>
                        <div className="col-md h6 text-muted">
                            {diffCheck(data.meta?.type, data.type)}
                        </div>
                    </div>
                    <div className="row mt-4">
                        <div className="col-md-4 h6">
                            Status
                        </div>
                        <div className="col-md h6 text-muted">
                            {diffCheck(data.meta?.status, data.status)}
                        </div>
                    </div>
                    <div className="row mt-4">
                        <div className="col-md-4 h6">
                             ID Type
                        </div>
                        <div className="col-md h6 text-muted">
                            {diffCheck(data.meta?.idType, data.idType)}
                        </div>
                    </div>
                    <div className="row mt-4">
                        <div className="col-md-4 h6">
                           ID Value
                        </div>
                        <div className="col-md h6 text-muted">
                            {diffCheck(data.meta?.idValue, data.idValue)}
                        </div>
                    </div>
                    <div className="row mt-4">
                        <div className="col-md-4 h6">
                           Side
                        </div>
                        <div className="col-md h6 text-muted">
                            {diffCheck(data.meta?.side, data.side)}
                        </div>
                    </div>
                    <div className="row mt-4">
                        <div className="col-md-4 h6">
                            Rejection Reason
                        </div>
                        <div className="col-md h6 text-muted">
                            {diffCheck(data.meta?.rejectionReason, data.rejectionReason)}
                        </div>
                    </div>
                </div>    
            </Modal.Body>
            <Modal.Footer className="justify-content-around">
                <button
                    type="button"
                    onClick={onHide}
                    className="btn btn-secondary btn-elevate px-5"
                >
                    Cancel
                </button>
                <Link 
                    to={`/users/view/${data?.userId}/documents`}
                    target="_blank"
                    onClick={onHide}
                    className="btn btn-primary btn-elevate px-5"
                >
                    View User Documents
                </Link>
            </Modal.Footer>
          </Modal>
}

export default KYCDocument;